import { Component } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';
import {
	FormGroupComponent,
	ItemComponent,
	LinkComponent,
	ListDetailComponent,
	SwitchComponent,
	TextareaComponent,
	TileComponent,
} from '@tecalisdev/infinity';
import { OPERATION_TYPE } from '../../../../operations/models/operations.models';
import { WorkflowFormOperationPanelBase } from './workflow-form-operation-panel.base';

/**
 * Panel UI de FINISH en el editor (NIF-530 / NIF-762 / NIF-1026).
 * Abrir cuando: mensajes de resultado, redirects o callbacks.
 */
@Component({
	selector: 'app-workflow-form-finish-panel',
	imports: [
		ReactiveFormsModule,
		TranslatePipe,
		TileComponent,
		FormGroupComponent,
		TextareaComponent,
		ItemComponent,
		LinkComponent,
		ListDetailComponent,
		SwitchComponent,
	],
	templateUrl: './workflow-form-finish-panel.component.html',
})
export class WorkflowFormFinishPanelComponent extends WorkflowFormOperationPanelBase {
	protected readonly operationType = OPERATION_TYPE.FINISH;

	public openResultMessagesModal(): void {
		this.host.openFinishResultMessagesModal();
	}
}
